var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90723 0C10.7219 5.25348e-05 13.8145 3.09039 13.8145 6.90234C13.8144 8.35393 13.3646 9.70005 12.5986 10.8115L15.085 13.2354C15.5941 13.7317 15.5996 14.5482 15.0967 15.0508C14.6025 15.5446 13.803 15.5491 13.3027 15.0615L10.7881 12.6113C9.68187 13.3637 8.34625 13.8047 6.90723 13.8047C3.09257 13.8047 7.24648e-05 10.7143 0 6.90234C0 3.09036 3.09252 0 6.90723 0ZM6.90723 2.2666C4.34524 2.2666 2.26855 4.34222 2.26855 6.90234C2.26863 9.46241 4.34529 11.5381 6.90723 11.5381C9.46912 11.538 11.5458 9.46238 11.5459 6.90234C11.5459 4.34225 9.46916 2.26665 6.90723 2.2666Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.93728fcd2549fe01edee9822791e6b3c.svg";
export { ForwardRef as ReactComponent };